module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b90cc1cc7baaf6838517114af748ccd4.png";